import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
let VueGtm = require('vue-gtm')

Vue.config.productionTip = false
Vue.use(VueGtm, {
  id: 'GTM-M34B263', // Your GTM ID
  enabled: process.env.NODE_ENV === 'production',
  debug: false, // Whether or not display console logs debugs (optional)
  vueRouter: router // Pass the router instance to automatically sync with router (optional)
})

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
